import React from "react";
import { RecommendationInfo } from "src/model/Recommendation";
import MetricsUtil from "src/utils/MetricsUtil";
import { withTranslation, WithTranslation } from "react-i18next";
import { KatIcon, KatLabel, KatPopover } from "@amzn/katal-react";
import { getCurrencyString } from "src/utils/ProgramDataUtil";
import { RECOMMENDATION_LOWASP } from "src/config/Config";

interface OwnProps {
    readonly metricsUtil?: MetricsUtil,
    readonly recommendationInfo: RecommendationInfo
}

type Props = OwnProps & WithTranslation;

interface State {
}

export class PriceRecommendationComponent extends React.Component<Props, State> {
    private readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);

        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    handleShow(): (event: KatPopover.ShowEvent) => void {
        return (event: KatPopover.ShowEvent) => {
            if (this.metricsUtil) {
                this.metricsUtil.publishCounter('priceRecommendation', 'show');
            }
        };
    }

    producePriceRecommendation() {
        return (
            <>
                <KatPopover triggerType="hover" katAriaBehavior="tooltip" position="right-start" onShow={this.handleShow()}>
                    <KatIcon slot="trigger" name="comment" size="small" className="tip-icon"/>
                    <KatLabel text={this.generatePriceRecommendationDescription()} className="popover-content"/>
                </KatPopover>
            </>
        );
    }

    generatePriceRecommendationDescription(): string {
        const {t, recommendationInfo} = this.props;
        const attributes = recommendationInfo.attributes;
        const LOW_REFERRAL_FEE_RATE = (Number(attributes['LOW_REFERRAL_FEE_RATE']) * 100).toFixed(0);
        const HIGH_REFERRAL_FEE_RATE = (Number(attributes['HIGH_REFERRAL_FEE_RATE']) * 100).toFixed(0);
        const YOUR_CURRENT_PRICE = getCurrencyString({
            amount: Number(attributes['YOUR_CURRENT_PRICE']),
            currency: attributes['CURRENCY_CODE']
        });
        const SUGGESTED_PRICE = getCurrencyString({
            amount: Number(attributes['SUGGESTED_PRICE']),
            currency: attributes['CURRENCY_CODE']
        });
        return t('SC_FBA_Calc_info_lowAspRecommendation',
            {
                X: `${YOUR_CURRENT_PRICE}`,
                Y: `${SUGGESTED_PRICE}`,
                A: `${HIGH_REFERRAL_FEE_RATE}%`,
                B: `${LOW_REFERRAL_FEE_RATE}%`
            });
    }

    render() {
        const {recommendationInfo} = this.props;

        if (recommendationInfo && recommendationInfo.communicationType === RECOMMENDATION_LOWASP) {
            return this.producePriceRecommendation();
        } else {
            return (<></>);
        }
    }
}

export default withTranslation()(PriceRecommendationComponent);
